<template>
  <el-dialog
    class="dialog-v2"
    :v-dialogDrag="dialogDrag"
    :custom-class="className"
    @opened="opened"
    :ref="dialogRef"
    :height="height"
    v-bind="{...$attrs}"
    v-on="{...$listeners}"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :title="title"
    :visible.sync="dialogVisible"
    :before-close="handleClose"
    :top="top"
    append-to-body
  >
    <div class="dialog-content" :class="{ 'min-height': needMinHeight }" :style="contentStyle" v-loading="loading">
      <slot name="body"></slot>
    </div>
    <slot name="footer" slot="footer"></slot>
  </el-dialog>
</template>

<script>
  export default {
    name: "bsp-dialog",
    props: {
      //title
      title: {
        type:String,
        default:''
      },
      //title
      className: {
        type:String,
        default:''
      },
      //ref
      dialogRef: {
        type:String,
        default:''
      },
      // width
      height: {
        type: String,
        default: ''
      },
      // visible
      dialogVisible: {
        type: Boolean,
        default: false
      },
      top: {
        type: String,
        default() {
          return '2vh'
        }
      },
      dialogDrag: {
        type: Boolean,
        default: false
      },
      contentStyle: {
        type: Object,
        default() {
          return {}
        }
      },
      needMinHeight: {
        type: Boolean,
        default: true
      }
    },
    methods: {
      handleClose(done) {
        this.$emit("closeButton")
        //this.$emit("close")
      },
      opened(){
        this.$emit("opened")
      }
    }
  };
</script>

<style lang="scss" scoped>
  .dialog-content {
    position: relative;
    overflow-y: auto;
    overflow-x: hidden;
    .min-height {
      min-height: 500px;
    }
  }
  ::v-deep .dialog-footer {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
</style>
